module.exports = __webpack_public_path__ + "static/media/shoeRight.aaeaf9d2.png";